function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The Hover plugin follows the mouse and shows a timestamp
 */
import BasePlugin from '../base-plugin.js';
var defaultOptions = {
  lineWidth: 1,
  labelSize: 11
};

var HoverPlugin = /*#__PURE__*/function (_BasePlugin) {
  _inherits(HoverPlugin, _BasePlugin);

  var _super = _createSuper(HoverPlugin);

  function HoverPlugin(options) {
    var _this;

    _classCallCheck(this, HoverPlugin);

    _this = _super.call(this, options || {});

    _this.unsubscribe = function () {
      return undefined;
    };

    _this.onPointerMove = function (e) {
      if (!_this.wavesurfer) return; // Position

      var width = _this.wavesurfer.getWrapper().clientWidth;

      var offsetX = e.offsetX;
      var relX = Math.min(1, Math.max(0, offsetX / width));
      var posX = Math.min(width - _this.options.lineWidth - 1, offsetX);
      _this.wrapper.style.transform = "translateX(".concat(posX, "px)");
      _this.wrapper.style.opacity = '1'; // Timestamp

      var duration = _this.wavesurfer.getDuration() || 0;
      _this.label.textContent = _this.formatTime(duration * relX);
      var labelWidth = _this.label.offsetWidth;
      _this.label.style.transform = posX + labelWidth > width ? "translateX(-".concat(labelWidth + _this.options.lineWidth, "px)") : ''; // Emit a hover event with the relative X position

      _this.emit('hover', relX);
    };

    _this.onPointerLeave = function () {
      _this.wrapper.style.opacity = '0';
    };

    _this.options = Object.assign({}, defaultOptions, options); // Create the plugin elements

    _this.wrapper = document.createElement('div');
    _this.label = document.createElement('span');

    _this.wrapper.appendChild(_this.label);

    return _this;
  }

  _createClass(HoverPlugin, [{
    key: "addUnits",
    value: function addUnits(value) {
      var units = typeof value === 'number' ? 'px' : '';
      return "".concat(value).concat(units);
    }
    /** Called by wavesurfer, don't call manually */

  }, {
    key: "onInit",
    value: function onInit() {
      var _this2 = this;

      if (!this.wavesurfer) {
        throw Error('WaveSurfer is not initialized');
      }

      var wsOptions = this.wavesurfer.options;
      var lineColor = this.options.lineColor || wsOptions.cursorColor || wsOptions.progressColor; // Vertical line

      this.wrapper.setAttribute('part', 'hover');
      Object.assign(this.wrapper.style, {
        position: 'absolute',
        zIndex: 10,
        left: 0,
        top: 0,
        height: '100%',
        pointerEvents: 'none',
        borderLeft: "".concat(this.addUnits(this.options.lineWidth), " solid ").concat(lineColor),
        transition: 'opacity .1s ease-in'
      }); // Timestamp label

      this.label.setAttribute('part', 'hover-label');
      Object.assign(this.label.style, {
        display: 'block',
        backgroundColor: this.options.labelBackground,
        color: this.options.labelColor,
        fontSize: "".concat(this.addUnits(this.options.labelSize)),
        transition: 'transform .1s ease-in',
        padding: '2px 3px'
      }); // Append the wrapper

      var container = this.wavesurfer.getWrapper();
      container.appendChild(this.wrapper); // Attach pointer events

      container.addEventListener('pointermove', this.onPointerMove);
      container.addEventListener('pointerleave', this.onPointerLeave);

      this.unsubscribe = function () {
        container.removeEventListener('pointermove', _this2.onPointerMove);
        container.removeEventListener('pointerleave', _this2.onPointerLeave);
      };
    }
  }, {
    key: "formatTime",
    value: function formatTime(seconds) {
      var minutes = Math.floor(seconds / 60);
      var secondsRemainder = Math.round(seconds) % 60;
      var paddedSeconds = "0".concat(secondsRemainder).slice(-2);
      return "".concat(minutes, ":").concat(paddedSeconds);
    }
    /** Unmount */

  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(HoverPlugin.prototype), "destroy", this).call(this);

      this.unsubscribe();
      this.wrapper.remove();
    }
  }], [{
    key: "create",
    value: function create(options) {
      return new HoverPlugin(options);
    }
  }]);

  return HoverPlugin;
}(BasePlugin);

export default HoverPlugin;